import { DateTimeFormat, diffDateTime } from '../../lib/date';
import { routeCreator as campaignRouteCreator } from '../Campaign/utils';

const TRANSACTIONS_BASE_URL = '/transactions';

export const routeCreator = {
  base: () => TRANSACTIONS_BASE_URL,
  details: (id: string) => `${TRANSACTIONS_BASE_URL}/${id}`,
  campaignOfferDetails: campaignRouteCreator.offerDetails,
};

export const shortenId = (id: string) => id.substr(0, 8);

export const getDateDiff = (first: Date | undefined, second: Date | undefined) => {
  if (!first || !second) return 0;
  return diffDateTime(first, second, 'millisecond');
};

export const DATE_FORMAT = DateTimeFormat.DateTime24h;

export const getMaskedCardNumber = (
  binRange: string | null | undefined,
  last4: string | null | undefined,
): string | null => {
  return binRange || last4 ? `${binRange ?? ''}****${last4 ?? ''}` : null;
};
